"use strict";
/**
 * In this file are components used for projecting data on-the-fly.
 * The file 'worker_projection.js' contains a web worker which computes t-SNE, UMAP usw in
 * a seperate thread to make the UI not lag during projection steps.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClusterWindow = void 0;
const styles_1 = require("@material-ui/core/styles");
const Card_1 = require("@material-ui/core/Card");
const CardHeader_1 = require("@material-ui/core/CardHeader");
const core_1 = require("@material-ui/core");
const Close_1 = require("@material-ui/icons/Close");
const CircularProgress_1 = require("@material-ui/core/CircularProgress");
const React = require("react");
/**
 * Styles for the projection card that allows to stop/resume projection steps.
 */
const useStylesCluster = styles_1.makeStyles(theme => ({
    root: {
        display: 'flex',
        margin: '8px 0',
        pointerEvents: 'auto'
    },
    details: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
    },
    content: {
        flex: '1 0 auto',
    },
    cover: {
        width: 151,
    },
    controls: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        paddingLeft: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        width: '100%'
    },
    playIcon: {
        height: 38,
        width: 38,
    },
}));
exports.ClusterWindow = ({ worker, onClose }) => {
    if (worker == null) {
        return React.createElement("div", null);
    }
    const classes = useStylesCluster();
    return React.createElement(Card_1.default, { className: classes.root },
        React.createElement("div", { className: classes.details },
            React.createElement(CardHeader_1.default, { avatar: React.createElement("div", null), action: React.createElement(core_1.IconButton, { onClick: (e) => {
                        onClose();
                    } },
                    React.createElement(Close_1.default, null)), title: 'Cluster Progress', subheader: `hdbscan*` }),
            React.createElement("div", { className: classes.controls },
                React.createElement(CircularProgress_1.default, null))));
};
